module.exports = __webpack_public_path__ + "static/bg08-e5ee5686515adec18284f7962d4ab429.jpg";